var classes = {"root":"oz7PS","underlineText":"ysZFF"};

export { classes as default };
